// Layout templates: named grid arrangements supporting 1 to 5 panels.
//
// Each template maps to a CSS class in Styles/dashboard.css that defines the
// grid columns/rows and named areas. Panels are placed into areas in order:
// panel index 0 -> area "a", 1 -> "b", and so on (see AREA_NAMES).

export const AREA_NAMES = ['a', 'b', 'c', 'd', 'e'];

export const LAYOUT_TEMPLATES = {
  single: {
    id: 'single',
    label: 'Single',
    panelCount: 1,
    className: 'lt-single',
  },
  'cols-2': {
    id: 'cols-2',
    label: 'Two Columns',
    panelCount: 2,
    className: 'lt-cols-2',
  },
  'rows-2': {
    id: 'rows-2',
    label: 'Two Rows',
    panelCount: 2,
    className: 'lt-rows-2',
  },
  'main-right': {
    id: 'main-right',
    label: 'Main + Side',
    panelCount: 2,
    className: 'lt-main-right',
  },
  'tri-bottom': {
    id: 'tri-bottom',
    label: 'Two Top + Wide Bottom',
    panelCount: 3,
    className: 'lt-tri-bottom',
  },
  'tri-right': {
    id: 'tri-right',
    label: 'Main + Two Right',
    panelCount: 3,
    className: 'lt-tri-right',
  },
  'tri-right-stack': {
    id: 'tri-right-stack',
    label: 'Main + Stacked Right',
    panelCount: 3,
    className: 'lt-tri-right-stack',
  },
  quad: {
    id: 'quad',
    label: 'Quad (60/40 + 50/50)',
    panelCount: 4,
    className: 'lt-quad',
  },
  'quad-right': {
    id: 'quad-right',
    label: 'Main + Three Right',
    panelCount: 4,
    className: 'lt-quad-right',
  },
  penta: {
    id: 'penta',
    label: 'Five',
    panelCount: 5,
    className: 'lt-penta',
  },
};

export const TEMPLATE_LIST = Object.values(LAYOUT_TEMPLATES);

export function getTemplate(id) {
  return LAYOUT_TEMPLATES[id] || LAYOUT_TEMPLATES['tri-bottom'];
}
